interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/fdef5987-68a4-4db5-abaa-06ff7eec96d2.png" 
              alt="HORAL d.o.o. Logo" 
              className="h-10 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-800 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vpn')}
              className="text-gray-800 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              VPN
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-800 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-800 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('company')}
              className="text-gray-800 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer"
            >
              Company
            </button>
          </div>

          <button
            onClick={() => scrollToSection('vpn')}
            className="hidden md:block bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-2.5 rounded-full font-medium hover:shadow-lg hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
